'use client';
import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, Typography } from '@mui/material';
import { Trash01 } from 'untitledui-js-base';

interface HideStatementDialogProps extends DialogProps {
  onAccept: () => void;
  isLoading?: boolean;
}

export const HideStatementDialog = ({ onAccept, isLoading, onClose, open, ...props }: HideStatementDialogProps) => (
  <Dialog open={Boolean(open)} onClose={onClose} maxWidth="md" {...props}>
    <DialogTitle id="alert-dialog-title">Odstranění záznamu</DialogTitle>
    <DialogContent>
      <Typography>Opravdu chcete smazat tento záznam?</Typography>
    </DialogContent>
    <DialogActions
      sx={{
        paddingX: 4,
        paddingY: 2,
        flexDirection: { xs: 'column-reverse', md: 'row' },
        gap: 2
      }}
    >
      <Button onClick={() => onClose?.({}, 'backdropClick')}>Zavřít</Button>
      <Button
        variant="contained"
        color="error"
        loading={isLoading}
        size="large"
        startIcon={<Trash01 />}
        onClick={onAccept}
      >
        Smazat záznam
      </Button>
    </DialogActions>
  </Dialog>
);
